export function RemovePlusFromString(str) {
    return str.replace(/\+/g, '');
}